/**
 * Thin fetch wrapper for the preview-view endpoint (round 2, AC 4 + AC 5).
 *
 * GET /api/tests/preview/:attemptId
 *
 * Returns the candidate-facing pre-screen data for a preview Attempt.
 * Used by the PreviewPage component (/tests/preview/:attemptId).
 */

export interface PreviewViewTest {
  id: string;
  title: string;
  task_brief_md: string | null;
  task_artifact_url: string | null;
  estimated_minutes: number;
  time_limit: number;
}

export interface PreviewViewPayload {
  test: PreviewViewTest;
}

export type PreviewViewEnvelope =
  | { ok: true; data: PreviewViewPayload }
  | { ok: false; error: { code: string; message: string; field?: string } };

/**
 * Fetch the candidate pre-screen payload for a preview Attempt.
 *
 * The endpoint requires System Admin authentication (same-origin session
 * cookie). The admin opens /tests/preview/:attemptId in a new tab from
 * the edit page, so the admin cookie is present.
 */
export async function getPreviewView(
  attemptId: string,
): Promise<PreviewViewEnvelope> {
  const res = await fetch(`/api/tests/preview/${encodeURIComponent(attemptId)}`, {
    method: 'GET',
    credentials: 'same-origin',
  });
  const text = await res.text();
  try {
    return JSON.parse(text) as PreviewViewEnvelope;
  } catch {
    return {
      ok: false,
      error: {
        code: 'parse_error',
        message: `unparseable response: ${text}`,
      },
    };
  }
}
